export const Scanlines = () => {
  return (
    <>
      <div className="crt-scanlines" aria-hidden="true" />
      <div className="scanline-bar" />
    </>
  );
};

export default Scanlines;
